import { createAction } from 'redux-actions';
import { PapiUser } from '@wix/da-papi-types';

export interface FetchArtAuthorPayload {
  username: string;
}

export interface FetchArtAuthorSuccessPayload {
  user: PapiUser;
}

export const fetchArtAuthor = createAction(
  'ART_BRANDED_POPUP.FETCH_ART_AUTHOR',
  (payload: FetchArtAuthorPayload) => payload
);

export const fetchArtAuthorSuccess = createAction(
  'ART_BRANDED_POPUP.FETCH_ART_AUTHOR_SUCCESS',
  (payload: FetchArtAuthorSuccessPayload) => payload
);
